import { render, staticRenderFns } from "./EditTagPage.vue?vue&type=template&id=595cb89e&"
import script from "./EditTagPage.vue?vue&type=script&lang=js&"
export * from "./EditTagPage.vue?vue&type=script&lang=js&"
import style0 from "./EditTagPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports